import { create } from "zustand";

interface source {
  projectId?: string;
  projectName?: string;
}
interface data {
  setShowChatDrawer: (show: boolean, source?: source) => void;
  showChatDrawer: boolean;
  source: source;
}

const useChatbotDrawer = create<data>((set) => ({
  showChatDrawer: false,
  source: {
    projectId: undefined,
    projectName: undefined,
  },
  setShowChatDrawer: (show, source) => set({ showChatDrawer: show, source }),
}));
export default useChatbotDrawer;
